import React, { useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import Spinner from "../../../shared/spinner/Spinner";
import Carousel from "react-bootstrap/Carousel";
import { get, post, handleError } from "../../../shared/HttpReq";
import { Toast } from "../../../shared/toaster/Toaster";
import AddDetails from "../../layout/Modals/Add_Details_Modal";
import Auth from "../../../auth/Auth";
import moment from "moment";
import AppContext from "../../../shared/AppContext";
import "react-datepicker/dist/react-datepicker.css";

import MinusSign from "../../../assests/images/minusSign.svg";
import AddSign from "../../../assests/images/Group 108.svg";
import PeopleLogo from "../../../assests/images/People_Icon.svg";
import ArrowBack from "../../../assests/images/Vector5.png";
import phonepng from "../../../assests/images/phone.png";
import canclePng from "../../../assests/images/cancle.png";
import mailpng from "../../../assests/images/mail.png";

import DatePicker from "react-datepicker";

function Adventure_info(props) {
  const { setCompanyInfo } = useContext(AppContext);
  let date = new URLSearchParams(useLocation().search).get("date");

  // date = moment.utc(date).local();
  const route = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });
  const [openModel, setOpenModal] = useState(false);
  const [excursionList, setExcursionData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [timing, setTimings] = useState([]);
  const [time, setSelectedTime] = useState("");
  // const [priceValue, setPriceValue] = useState(null);
  const [startDate, setStartDate] = useState({
    date: new Date(date),
    time: moment(date).isAfter(moment())
      ? moment(date).format("HH:mm")
      : moment().format("HH:mm"),
  });
  const [isOpen, setIsOpen] = useState(false);
  const [cardData, setCardData] = useState(null);
  const [bookingPriceList, updateBookingPriceList] = useState([]);
  const [showError, setError] = useState({ ticket: false, time: false });

  function convertDateToString(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  const handleChange = (e) => {
    setIsOpen(!isOpen);
    const date = convertDateToString();
    setStartDate({
      date: new Date(e),
      time: moment(date).isAfter(moment())
        ? moment(date).format("HH:mm")
        : moment().format("HH:mm"),
    });
  };

  // console.log("currentTime", startDate.date);

  // console.log("startDate", moment.utc(startDate.date).local().format('MMM Do YYYY'));

  const handleClick = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const params = useParams();




  function selectTimeslot(e) {
    setSelectedTime(e.target.value);
    if (time !== null) {
      setError((prev) => ({ ...prev, time: false }));
      return;
    }
  }

  const getSingleExcusionDetail = async () => {
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/excursion-detail/${props.match.params.companyId}/${props.match.params.excursionId}`,
        await get()
      )
    );
    setCompanyInfo({ name: res.company.name });
    if (res.status === 200) {
      var total = 0;
      setExcursionData(res);
      var timing = res.timings.split(",");
      setTimings(timing);
      if (res) {
        res.pricing.forEach(function (value) {
          value.count = 0;
          total = total + value.count * value.price;
          value.totalPrice = value.price;
        });
        updateBookingPriceList(res.pricing);
        setTotalValue(total);
      }
    } else {
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: res.errors,
      });
    }
    setLoading(false);
    setTimeout(() => {
      SetToaster({
        show: false,
        type: "",
        content: "",
      });
    }, 3000);
  };

  //add cart
  const cardDetailSubmit = async (data) => {
    setLoading(true);
    let res = await handleError(
      await fetch(`${process.env.REACT_APP_BASE_URL}/addCart`, await post(data))
    );

    if (res.status === 200) {
      setLoading(false);
      SetToaster({
        show: false,
        type: "success",
        content: "Added to cart successfully.",
      });
      route.push("/CartDetails/" + params.companyId);
    } else {
      SetToaster({
        show: true,
        type: "danger",
        content: res.errors,
      });
    }
  };

  const reqBookHandler = (e) => {
    e.preventDefault();
    let count = 0;
    if (!time) {
      setError((prev) => ({ ...prev, time: true }));
      return;
    }
    for (const item of bookingPriceList) {
      count += item.count;
    }
    if (count < 1) {
      setError((prev) => ({ ...prev, ticket: true }));
      return;
    }
    const data = {
      company: props.match.params.companyId,
      excursion: props.match.params.excursionId,
      category: bookingPriceList,
      bookedTo: moment(startDate.date).format("YYYY-MM-DD"),
      time: time,
    };

    setCardData(data);
    // Auth.isUserAuthenticated() ? route.push("/CartDetails") : setOpenModal(true);
    if (Auth.isUserAuthenticated()) {
      cardDetailSubmit(data);
      // route.push(
      //   "/CartDetails/" +
      //     params.companyId
      // );
      // route.push(
      //   "/CartDetails/" +
      //     params.companyId +
      //     "/" +
      //     params.excursionId +
      //     "?date=" +
      //     moment(startDate).format('YYYY-MM-DD')
      // );
    } else {
      setOpenModal(true);
    }
  };

  // function subtractMonths(date, months, type) {
  //   // setCalenderDate( date.setMonth(
  //   //   type == "next" ? date.getMonth() + months : date.getMonth() - months
  //   // ))
  //   date.setMonth(
  //     type == "next" ? date.getMonth() + months : date.getMonth() - months
  //   );

  //   return date;
  // }

  // function changeMonth(type) {
  //   const dates = new Date(calenderDate);
  //   const result2 = subtractMonths(dates, 1, type);
  //   setCalenderDate(
  //     result2.getFullYear() +
  //       "-" +
  //       (result2.getMonth() < 9
  //         ? "0" + (result2.getMonth() + 1)
  //         : result2.getMonth() + 1) +
  //       "-" +
  //       result2.getDate()
  //   );
  // }

  function oChangePrice(booking, type) {
    // if (booking.totalPrice <= 0) {
    //   return;
    // }
    let bookingArray = [...bookingPriceList];

    // var totalAmount = 0;

    bookingArray.forEach((el) => {
      if (el._id === booking._id) {
        if (type === "increment") {
          setError((prev) => ({ ...prev, ticket: false }));
          setTotalValue(totalValue + el.price);
          // el.totalPrice += el.price;
          el.count = el.count + 1;
          // setTotalValue(el.totalPrice);
        } else {
          if (booking.totalPrice <= 0) {
            setError((prev) => ({ ...prev, ticket: true }));
            return;
          }

          // el.totalPrice -= el.price;
          if (el.count > 0) {
            setTotalValue(totalValue - el.price);
            el.count = el.count - 1;
          }

          // setTotalValue(el.totalPrice);
        }
      }
    });

    updateBookingPriceList(bookingArray);
  }

  useEffect(() => {
    getSingleExcusionDetail();
  }, [startDate]);

  // useEffect(async () => {
  //   await getSingleExcusionDetail();
  // }, []);

  const sum = bookingPriceList.reduce((accumulator, object) => {
    return accumulator + object.count;
  }, 0);

console.log("excursionList?.images?.length",excursionList?.images?.length);

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />
      <div className="pt-0">
        <div className="container">
          <div className="mb-5">
            {/* <Link to={`/?id=${Auth.getCompanyHexaID()}`} className="backbtn"> */}
            <p onClick={() => route.goBack()} className="backbtn">
              <img src={ArrowBack} alt="" className="" /> Back
            </p>

            {/* </Link> */}
          </div>
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <div className="adventure_slider">
                {excursionList?.images?.length <= 1 ? (
                 <img
                   className="d-block w-100 slider_image slider_single_image"
                   src={`${process.env.REACT_APP_BASE_URL}/media/?file=${excursionList?.images[0]}`}
                   alt="First slide"
                 />
                ) : ( 
                  // <img
                  //   className="d-block w-100 slider_image"
                  //   src={`${process.env.REACT_APP_BASE_URL}/media/?file=${excursionList?.images[0]}`}
                  //   alt="First slide"
                  // />
                  <Carousel>
                  {excursionList.images
                    ? excursionList.images.map((image, i) => (
                        <Carousel.Item interval={1000} key={i}>
                          <img
                            className="d-block w-100 slider_image"
                            src={`${process.env.REACT_APP_BASE_URL}/media/?file=${image}`}
                            alt="First slide"
                          />

                          <Carousel.Caption></Carousel.Caption>
                        </Carousel.Item>
                      ))
                    : null}
                </Carousel>
                )}
              </div>
              <div className="adventure_booking_details">
                <div className="adventure_booking_details_view d-flex justify-content-between">
                  <h4 className="adventure_booking_details_view_heading">
                    {excursionList.name}
                  </h4>
                </div>

                <div className="adventure_booking_details_about mt-4">
                  <h4 className="adventure_booking_details_about_heading">
                    About
                  </h4>
                  <p className="adventure_booking_details_about_para">
                    {excursionList.description}
                  </p>
                </div>
                <div className="adventure_booking_details_about mt-4">
                  <h4 className="adventure_booking_details_about_heading">
                    When and Where to Meet
                  </h4>
                  <p className="adventure_booking_details_about_para">
                    {excursionList.location}
                  </p>
                </div>
                <div className="adventure_booking_details_about mt-4">
                  <h4 className="adventure_booking_details_about_heading">
                    What to Bring
                  </h4>
                  <p className="adventure_booking_details_about_para">
                    {excursionList.featured_equipment}
                  </p>
                </div>
                <div className="adventure_booking_details_about mt-4">
                  <h4 className="adventure_booking_details_about_heading">
                    Cancellation Policy
                  </h4>
                  <p className="adventure_booking_details_about_para">
                    {excursionList.cancellation_policy}
                  </p>
                </div>

                <div className="adventure_booking_details_contact">
                  <h4 className="adventure_booking_details_contact_heading">
                    Contact Info
                  </h4>
                  <span>
                    <img src={phonepng} alt="" className="phone_icon" />{" "}
                    <span className="phone_number">
                      {excursionList.company
                        ? excursionList.company.phoneNumber
                        : ""}
                    </span>
                  </span>
                  <p className="mb-0 d-flex">
                    <img src={mailpng} alt="" />
                    <span className="phone_number align-self-center">
                      {excursionList.company ? excursionList.company.email : ""}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="booking_view">
                <p className="booking_date bookind_date_view position-relative">
                  Booking Date : {""}
                  <button
                    className="example-custom-input"
                    onClick={handleClick}
                  >
                    {moment(startDate.date).format("MMM Do YYYY")}
                  </button>
                </p>
                {isOpen && (
                  <div className="position-relative">
                    <DatePicker
                      selected={startDate.date}
                      onChange={handleChange}
                      minDate={new Date()}
                      inline
                    />
                  </div>
                )}
                <h4 className="booking_view_heading">Booking Details</h4>

                {bookingPriceList.length
                  ? bookingPriceList.map((booking) => (
                      <div
                        className="booking_view-client_booking d-flex"
                        key={booking._id}
                      >
                        <div className="client_booking-box d-flex">
                          <div className="box_info-img">
                            <img src={PeopleLogo} alt="Vector booking" />
                          </div>
                          <div className="box-info_data">
                            <h4>
                              <b>
                                {booking.type}{" "}
                                <span className="price">
                                  {booking.totalPrice ? '$' + booking.totalPrice.toFixed(2): 0}
                                  
                                </span>
                              </b>
                            </h4>
                            {/* <p>(13 - 64 years)</p> */}
                          </div>
                        </div>
                        <div className="client_booking-num d-flex">
                          <button
                            className="client_booking-num_increment"
                            onClick={() => {
                              oChangePrice(booking, "decrement");
                              // setPriceValue(priceValue+price.price)
                            }}
                          >
                            <img src={MinusSign} alt="btn increment" />
                          </button>
                          <div className="input-fild">
                            <input
                              type="number"
                              value={booking.count}
                              className="datanum"
                              min={0}
                              readOnly
                            />
                          </div>
                          <button
                            className="client_booking-num_decrement"
                            onClick={() => {
                              oChangePrice(booking, "increment");
                              // setPriceValue(priceValue+price.price)
                            }}
                          >
                            <img src={AddSign} alt="btn decrement" />
                          </button>
                        </div>
                      </div>
                    ))
                  : null}

                {showError.ticket ? (
                  <span className="text-danger">
                    Please select at-least one ticket
                  </span>
                ) : null}

                {sum > excursionList.max ? (
                  <p className="text-danger">
                    You can't purchase more than {excursionList.max} tickets at
                    a time.
                  </p>
                ) : (
                  ""
                )}

                <div className="time_view">
                  <h3 className="time_view_heading">Select a time</h3>

                  <div className="filter_box_wrapper">
                    <div className="section-filter_items d-flex flex-wrap">
                      {timing.length
                        ? timing.map((time, index) => (
                            <div className="filter_items-item" key={index}>
                              {/* {moment(`${date} ${currentTime}`).isAfter(moment(`${date} ${currentTime}`))} */}
                              {/* {time <= currentTime && ( */}
                              <div className="position-relative">
                                <input
                                  type="radio"
                                  name="timeslot"
                                  className="tip_box fp blue-bg "
                                  value={time}
                                  // valid and unvalid time enable and disabled section start

                                  disabled={
                                    moment(
                                      `${convertDateToString(startDate.date)} ${
                                        startDate.time
                                      }`
                                    ).isAfter(moment())
                                      ? false
                                      : moment(
                                          `${moment().format(
                                            "YYYY-MM-DD"
                                          )} ${time}`
                                        ).isAfter(
                                          moment(
                                            `${convertDateToString(
                                              startDate.date
                                            )} ${startDate.time}`
                                          ).format("YYYY-MM-DD HH:mm")
                                        )
                                      ? false
                                      : true
                                  }
                                  // valid and unvalid time enable and disabled section end

                                  onChange={selectTimeslot}
                                />
                                {moment(
                                  `${convertDateToString(startDate.date)} ${
                                    startDate.time
                                  }`
                                ).isAfter(moment()) ? (
                                  false
                                ) : moment(
                                    `${moment().format("YYYY-MM-DD")} ${time}`
                                  ).isAfter(
                                    moment(
                                      `${convertDateToString(startDate.date)} ${
                                        startDate.time
                                      }`
                                    ).format("YYYY-MM-DD HH:mm")
                                  ) ? (
                                  false
                                ) : (
                                  <img
                                    src={canclePng}
                                    alt=""
                                    className="cancle_btn"
                                  />
                                )}

                                <label htmlFor="twenty" className="timelable">
                                  {moment(time, ["HH:mm"]).format("h:mm A")}
                                </label>
                              </div>
                              {/* )} */}
                            </div>
                          ))
                        : null}
                    </div>

                    {showError.time ? (
                      <span className="text-danger">
                        Please select a time slot
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="booking_view-request d-flex">
                  <div className="request_totle_price">
                    <p>Price:</p>
                    <p className="price-tt everyday_color">
                      ${totalValue.toFixed(2)}
                    </p>
                  </div>

                  <div className="request_btn">
                    <button
                      className="blue-bg"
                      disabled={sum > excursionList.max}
                      onClick={(e) => {
                        reqBookHandler(e);
                        // localStorage.clear();
                      }}
                    >
                      Request to book
                    </button>
                  </div>
                </div>
                {openModel && (
                  <AddDetails cardData={cardData} setOpenModal={setOpenModal} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Adventure_info;
